// src/lib/black-friday-constants.ts

/**
 * Required Black Friday script version
 * Update this when you release a new BF script version
 */
export const REQUIRED_BF_SCRIPT_VERSION = "1.0.10";

/**
 * Black Friday date configuration
 */
export const BLACK_FRIDAY_DATES = {
  2025: "2025-11-28",
  2024: "2024-11-29",
  2023: "2023-11-24",
} as const;
